<button (click)="onClicked($event)" id="actionButtonSingle" class="appActionButtonSingle" [innerHTML]="icon"></button>
